import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const paiesSlice = createSlice({
    name: 'paies',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {
        resetDetailsPaies: (state) => {
            if (state.detailsPaies == null) {
                state.detailsPaies = ''
            } else {
                state.detailsPaies = null
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDetailsPaies.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsPaies.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.detailsPaies = action.payload
            })
            .addCase(fetchDetailsPaies.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })


            .addCase(fetchDetailsFichePaies.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsFichePaies.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.detailsFichePaies = action.payload
            })
            .addCase(fetchDetailsFichePaies.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })




            .addCase(fetchPaies.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchPaies.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchPaies.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createPaie.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createPaie.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createPaie.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deletePaie.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deletePaie.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deletePaie.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchPaies = createAsyncThunk(
    'paies/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/rh.paie.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch paies')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsPaies = createAsyncThunk(
    'Paies/fetchDetails',
    async (id) => {
        try {
            const journal = await BaseService.post(
                `/XML/compta.jr.load/get_journal_by_lbl`, { 'lbl': 'PAIE__' + id.id }
            )
            const fiche = await BaseService.post(
                `/XML/rh.paie.load/get_fiche_de_paie_one_paie`, { 'id': id.id }
            )
            const paie = await BaseService.post(
                `/XML/rh.paie.load/get_one_paie`, { 'id': id.id }
            )
            return { 'journal': journal.data, 'fiche': fiche.data, 'paie': paie.data }
        } catch (error) {
            throw new Error('Failed to fetch Paies')
        }
    }
)


export const fetchDetailsFichePaies = createAsyncThunk(
    'Paies/fetchDetailsFiche',
    async (id) => {
        try {
            const objtable = {
                'salaireDeBase': 'salaire De Base',
                'heursSup': 'Heures supplémentaires',
                'gratification': 'Gratification',
                'prime': 'Prime',
                'primeAnciennete': "Prime d'anciennete",
                'indeminiteImposable': "Indemnite Imposable",
                'indeminiteNImposable': "Indemnite Non Imposable",
                'avantage': 'Avantages',
                'salaireBruteImposable': 'Salaire Brute Imposable',
                'fraisProfessionnel': 'Frais Professionnel',
                'cnss': 'Prestations sociales Part salariale',
                'cnssPatronale': 'Prestations sociales Part Partonale',
                'amo': 'AMO Part salariale',
                'amoPartonale': 'AMO Part Partonale',
                'participationAmo': 'participation AMO',
                'cnssAllocationFamiliale': 'Allocations familiales',
                'taxeFormationProfessionnelle': 'Taxe Formation Professionnelle',
                'cimr': 'CIRM',
                'retraiteComplemenatire': 'Retraite Complementaire',
                'remboursementLogementSociale': 'Remboursement Logement Sociale',
                'salaireNetImposable': 'salaire Net Imposable',
                'impotBrut': 'Impot Brut',
                'deductionSurImpot': 'Deduction Sur Impot',
                'impotNet': 'Impot Net',
                'salaireNet': 'Salaire Net',
                'avance': 'Avances',
                'opposition': 'Oppositions',
                'netAPayer': 'Net À Payer'

            }

            const fiche = await BaseService.post(
                `/XML/rh.employe.load/get_one_fiche_de_paie`, { 'id': id.id }
            )

            const table = []
            Object.keys(objtable).map((key) => {
                if (typeof fiche?.data?.[0]?.[key] !== 'undefined') {
                    table.push({ 'key': objtable[key], 'value': fiche?.data?.[0]?.[key] })
                }


            })
            return { 'fiche': fiche.data, 'table': table }
        } catch (error) {
            throw new Error('Failed to fetch Paies')
        }
    }
)


export const editFicheDePaie = createAsyncThunk(
    'fiche/post',
    async (payload) => {
        const { data, formik, navigate, handleConfirm } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/rh.paie.send/modifier_fiche', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                handleConfirm()
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)
export const createPaie = createAsyncThunk(
    'paies/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/rh.paie.send/ajouter', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const confirmPaie = createAsyncThunk(
    'paies/confirm',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/rh.paie.send/confirmer', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)




export const editPaie = createAsyncThunk('paies/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/paies/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/paies')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deletePaie = createAsyncThunk(
    'paie/delete',
    async ({ id, setPaieAdded }) => {

        try {
            const response = await BaseService.post('/XML/rh.paie.send/delete', { 'id_paie': id })
            if (response.status === 200) {

                popNotification(deletion?.success)
                setPaieAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            popNotification(deletion?.error)
        }
    }
)

export const selectData = (state) => state.paies.data
export const selectIsLoading = (state) => state.paies.isLoading
export const selectError = (state) => state.paies.error
export const selectIsDeleted = (state) => state.paies.isDeleted
export const selectCurrentPage = (state) => state.paies.currentPage
export const resetDetailsPaies = paiesSlice.actions.resetDetailsPaies
export default paiesSlice.reducer
